var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Select } from 'ui/styled';
import { dataLoader } from 'utils/helpers';
import useUserSelect from './useUserSelect';
var UserSelect = function (_a) {
    var disabled = _a.disabled, defaultValue = _a.defaultValue, onChange = _a.onChange, _b = _a.placeholder, placeholder = _b === void 0 ? 'Users' : _b, showAnyText = _a.showAnyText, showActiveOnly = _a.showActiveOnly, staffOnly = _a.staffOnly, allowClear = _a.allowClear, navigatorIds = _a.value, size = _a.size, fontSize = _a.fontSize, mode = _a.mode, rest = __rest(_a, ["disabled", "defaultValue", "onChange", "placeholder", "showAnyText", "showActiveOnly", "staffOnly", "allowClear", "value", "size", "fontSize", "mode"]);
    var _c = useUserSelect(navigatorIds, showActiveOnly, staffOnly), functions = _c.functions, data = _c.data;
    var loading = data.loading, users = data.users;
    var debouncedSearch = functions.debouncedSearch, onPopupScroll = functions.onPopupScroll;
    var options = users === null || users === void 0 ? void 0 : users.map(function (user) { return ({
        label: "".concat(user.first_name, " ").concat(user.last_name),
        value: user.id
    }); });
    return (_jsx(Select, __assign({ disabled: disabled, placeholder: placeholder, value: navigatorIds || defaultValue, showSearch: { onSearch: debouncedSearch, filterOption: false }, popupMatchSelectWidth: false, notFoundContent: dataLoader(loading), allowClear: allowClear, onChange: onChange, onPopupScroll: onPopupScroll, "data-test": "usersFilter", loading: loading, options: options, size: size, fontSize: fontSize, mode: mode }, rest)));
};
export default UserSelect;
